import desktopBannerImg from "../images/Banner-LP-1920x300.png";
import mobileBannerImg from "../images/Banner-TelaValores-720x180.png";
import desktopBannerMinhaClaroImg from "../images/Banner-Desktop-Minha-Claro-Channels.png";
import mobileBannerMinhaClaroImg from "../images/Banner-Mobile-Minha-Claro-Channels.png";
import desktopBannerClaroControleImg from "../images/Banner-Controle-1920x300-LP.png";
import mobileBannerClaroControleImg from "../images/Banner-Controle-720x180-TelaValores.png";

const bannersConfig = {
  MINHA_CLARO_WEB: {
    mobile: mobileBannerMinhaClaroImg,
    desktop: desktopBannerMinhaClaroImg,
    alt: "Minha_claro_banner",
  },
  MINHA_CLARO_APP: {
    mobile: mobileBannerMinhaClaroImg,
    desktop: desktopBannerMinhaClaroImg,
    alt: "Minha_claro_app_banner",
  },
  CLARO_CONTROLE: {
    mobile: mobileBannerClaroControleImg,
    desktop: desktopBannerClaroControleImg,
    alt: "Claro_controle_banner",
  },
  DEFAULT: { mobile: mobileBannerImg, desktop: desktopBannerImg, alt: "Claro_default_banner" },
};

export default bannersConfig;
